<template>
  <v-card>
    <v-form ref="form" @submit.prevent="validate">
      <v-card-title></v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-row>
              <v-col cols="4">
                <v-text-field
                  label="Password Lama"
                  placeholder="Password Lama"
                  hide-details="auto"
                  :type="is_old_password_visible ? 'text' : 'password'"
                  outlined
                  :append-icon="is_old_password_visible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
                  @click:append="is_old_password_visible = !is_old_password_visible"
                  :rules="[v => !!v || 'Password Lama harus diisi!', v => (v && v.length >= 6) || 'Minimal 6 karakter']"
                  v-model="old_password"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col cols="4">
                <v-text-field
                  label="Password Baru"
                  placeholder="Password Baru"
                  hide-details="auto"
                  :type="is_new_password_visible ? 'text' : 'password'"
                  outlined
                  :append-icon="is_new_password_visible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
                  @click:append="is_new_password_visible = !is_new_password_visible"
                  :rules="[v => !!v || 'Password Baru harus diisi!', v => (v && v.length >= 6) || 'Minimal 6 karakter']"
                  v-model="new_password"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col cols="4">
                <v-text-field
                  label="Konfirmasi Password Baru"
                  placeholder="Konfirmasi Password Baru"
                  hide-details="auto"
                  :type="is_confirm_new_password_visible ? 'text' : 'password'"
                  outlined
                  :append-icon="is_confirm_new_password_visible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
                  @click:append="is_confirm_new_password_visible = !is_confirm_new_password_visible"
                  :rules="[
                    v => !!v || 'Konfirmasi Password Baru harus diisi!',
                    v => (v && v.length >= 6) || 'Minimal 6 karakter',
                  ]"
                  v-model="confirm_new_password"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col cols="12">
            <v-btn color="primary" type="submit" :loading="loadingButton">Simpan</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import axios from 'axios'

export default {
  props: ['setAlert'],
  setup() {
    return {
      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
    }
  },
  data() {
    return {
      is_old_password_visible: false,
      is_new_password_visible: false,
      is_confirm_new_password_visible: false,
      old_password: '',
      new_password: '',
      confirm_new_password: '',
      loadingButton: false,
    }
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.submit()
      }
    },
    submit() {
      if (this.new_password == this.confirm_new_password) {
        this.loadingButton = true
        const token = localStorage.getItem('token')
        axios
          .patch(
            `${process.env.VUE_APP_API_ENDPOINT}profile/change-password`,
            {
              old_password: this.old_password,
              new_password: this.new_password,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          )
          .then(res => {
            this.loadingButton = false
            if (res.status == 200) {
              const data = res.data
              this.setAlert({
                status: true,
                success: data.success,
                message: data.message,
              })
              this.$refs.form.reset()
            } else {
              this.setAlert({
                status: true,
                success: false,
                message: res.statusText,
              })
            }
          })
          .catch(err => {
            this.loadingButton = false
            const response = err.response
            const data = response.data
            this.setAlert({
              status: true,
              success: false,
              message: data.message,
            })
            if (data.message == 'Anda tidak diberikan akses!') {
              localStorage.removeItem('token')
              localStorage.removeItem('user')
              this.$router.push({ name: 'login' })
            }
          })
      } else {
        this.setAlert({
          status: true,
          success: false,
          message: 'Konfirmasi password baru tidak sama!',
        })
      }
    },
  },
}
</script>

<style>
</style>